<template>
  <div v-if="facetsToShow.length" class="breadcrumbs align-center">
    <!-- <span v-if="$store.state.filters.length" class="caption">Vos critères de filtre :</span> -->
    <v-chip
      v-for="(facet, i) in facetsToShow"
      :key="i"
      label
      small
      class="ma-2 red white--text"
      dark
      close
      @click:close="removeFacet(facet)"
    >
      <div v-if="facet.to || facet.from">
        <span v-if="facet.fieldType === 'date'">{{ formatDate(facet.from) }} </span>
        <span v-if="facet.fieldType === 'rangeSlider'">{{ facet.from }} </span>
        <span v-else-if="facet.from">{{ facet.from + 1 }} </span>

        <span v-if="facet.to && facet.from  && facet.fieldType !== 'rangeSlider'">-</span>

        <span v-if="facet.fieldType === 'date'"> {{ formatDate(facet.to) }}</span>
        <span v-if="facet.fieldType === 'rangeSlider' && facet.to !== facet.from"> - {{ facet.to }} </span>
        <span v-else-if="facet.to && facet.fieldType !== 'rangeSlider'"> {{ facet.to - 1 }}</span>
      </div>

      <div v-else>
        <span v-if="facet.fieldType === 'date'" v-text="facet.breadcrumbs ? facet.title + ': ' + formatDate(facet.value) : formatDate(facet.value)"></span>
        <span
          v-else
          v-text="facet.breadcrumbs || facet.breadcrumbTitle ? facet.title + ': ' + (facet.defaultValueLabel || facet.value) : facet.defaultValueLabel || facet.value"
        />
      </div>

    </v-chip>
      <!-- <div v-if="$store.state.filters.length" class="inline">
        <div @click="removeAllFacets()" class="d-flex pointer align-center">
          <v-icon small>mdi-close-circle-outline</v-icon
          ><span class="ml-1 caption">effacer tout</span>
        </div>
      </div> -->

  </div>
</template>
<script>
import dayjs from 'dayjs';

export default {
  props: {
    facets: Array,
  },
  methods: {
    formatDate(date) {
      return dayjs.utc(date, 'YYYY-MM-DD').format("DD-MM-YYYY");
    },
    removeFacet(item) {
      this.$store.commit("removeFilter", { id: item.id });

      // complex filters -> more thean 1 property to filter by
      if(item.filtersToDelete && item.filtersToDelete.length){
        item.filtersToDelete.map(filterId => {
          this.$store.commit("removeFilter", { id: filterId });
        })
      }
    }
  },
  computed: {
    facetsToShow() {
     return this.$store.state.filters.filter(selectedFilter => {
       if(!this.facets) return false

        return this.facets.some(facet => {

            // MULTIPLE HAS NEW STRUCTURE TO FIND A PARENT FIELD ASSOCIATED BY EACH FILTER FROM ELASTIC SEACH
            if(facet.isMultiFacet) return  facet.fields.some(field => field.field === selectedFilter.field)

            // SINGLE ONLY NEED TO FIND A BASE
            if(facet.field === selectedFilter.field) return true

            // NOTHING
            return false
        })

      })

    }
  }
};
</script>
<style lang="scss">
.breadcrumbs {
  min-height: 40px;
}
.clear-facets {
  text-decoration: underline;
  cursor: pointer;
}
.inline {
  display: inline-block;
}
.pointer {
  cursor: pointer;
}
</style>